var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.estate.is_discounted
    ? _c(
        "div",
        { staticClass: "estate-card-discount-container" },
        [
          _c("masked-image", {
            staticClass: "estate-card-discount-icon",
            attrs: { src: "/img/icons/arrow-down.svg", alt: "Prezzo ribassato" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "estate-card-discount" }, [
            _vm._v("\n        " + _vm._s(_vm.estate.previous_price) + "\n    ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "estate-card-percent-discount" }, [
            _vm._v(
              "\n        (-" +
                _vm._s(_vm.estate.discount_percentage) +
                ")\n    "
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }